import {password, required, confirmPassword} from '../units';
import validate from '../common';

const validations = {
  password: [required(), password()],
  password_confirm: [required(), password(), confirmPassword({field: 'password'})]
};

export default {
  validate: validate(validations)
};



// WEBPACK FOOTER //
// ./validators/forms/set-password.js